import React, { useEffect, useState } from "react";
import LeftSponsers from "./../leftSponsers/leftSponsers";
import RightSponsers from "./../rightSponsers/rightSponsers";
import * as api from "./../../api/api";
import { Link } from "react-router-dom";
import * as c from "./../../const";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import * as moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";

//REACT-WINDOW
// import { FixedSizeList as List } from "react-window";

import Pagination from "@material-ui/lab/Pagination";

import FormatQuoteRoundedIcon from "@material-ui/icons/FormatQuoteRounded";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     "& > * + *": {

//     },
//   },
// }));
const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
  customWidth: {
    maxHeight: 500,
    fontSize: "14px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const initialNews = {
  id: "",
  category_id: "",
  sponser_id: "",
  title: "",
  url: "",
  image: [],
  publication_type_id: "",
  key_word: "",
  is_active: "",
  publish_date: "",
  details: "",
  created_at: "",
  updated_at: "",
  category: {},
  sponsor: {},
};

export default function Body(props) {
  const classes = useStyles();
  const [news, setNews] = useState(initialNews);
  const [loader, setLoader] = useState(true);
  const [N, setN] = useState(1);
  const [limit, setLimit] = useState(20);
  const [newsBlog, setNewsBlog] = useState(initialNews);
  const [buttonLoad, setButtonLoad] = useState(false);
  const [heading, setHeading] = useState("");
  const from = Number((N - 1) * 10 - 1);
  const till = Number(N * 10 - 1);

  console.log("heading", heading);

  useEffect(() => {
    document.title = "121five.com";
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    newsApi();
    newsHeadlingApi();
  }, []);

  const newsApi = async () => {
    try {
      // let response = await api.newsHome();
      // setNews(response);
      setLoader(false);

      const response = await api.news_with_limit(20);
      setNewsBlog(response);
    } catch (e) {}
  };

  let newsArray = [];

  Object.keys(news).map((index) => {
    let publish_date = moment(new Date(news[index].publish_date)).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    const today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    if (news[index].is_active && publish_date < today) {
      newsArray.push(news[index]);
    }
  });

  const length = Math.ceil(news.length / 10);
  const url = c.URL;

  //

  const newsHeadlingApi = async () => {
    try {
      let response = await api.headline();
      console.log("response", response);
      setHeading(response);
      setLoader(false);
    } catch (e) {
      console.log(e);
    }
  };

  const showMore = async () => {
    setButtonLoad(true);
    const count = limit + 20;
    setLimit(count);

    try {
      const response = await api.news_with_limit(count);

      setNewsBlog(response);
      setButtonLoad(false);
    } catch (e) {}
    //  this.setState({ limit: this.state.limit + 20 });
    //  axios
    //      .get("/api/all-news/"+this.state.limit, {
    //          headers: {
    //              Authorization: `${"ABCDEFGHIJK"}`,
    //          },
    //      })
    //      .then((response) => {
    //          this.setState({ contact: response.data, loaded: true });
    //      })
    //      .catch((error) => {

    //          console.error(error);
    //      });
  };

  return (
    <div className="container">
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="left-sponsor">
                <LeftSponsers />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <h3 className="headingNews">Headlines</h3>
              <div className="headingScroll">
                {Object.keys(heading)
                  .slice(0, 6)
                  .map((i) => {
                    const title = heading[i].title;
                    const id = heading[i].id;
                    return (
                      <div
                        style={{
                          borderBottom: "1px dashed white",
                          borderWidth: "20%",
                        }}
                        key={i}
                      >
                        <Link
                          exact
                          to={"/blog/" + id}
                          params={{ testvalue: "hello" }}
                        >
                          <p className="carouselCaption">{title}</p>
                        </Link>
                      </div>
                      // </Marquee>
                    );
                  })}
                <Link
                  to={{
                    pathname: "/results",
                    state: {
                      data: {
                        category_id: 1,
                      },
                    },
                  }}
                >
                  <button className="headlineButton more-btn hvr-shutter-out-horizontal border-0 ml-2">
                    More Headline
                  </button>
                </Link>
              </div>
              <div className="mid-sponsor">
                <div className="card single-blog mb-3">
                  {/* {Object.keys(imageData).map((index, key) => { */}
                  {newsBlog.length > 1 &&
                    Object.keys(newsBlog).map((item, i) => {
                      // window.scrollTo(0, 0);
                      const url = c.URL;
                      let blogId = newsBlog[item].id;
                      let src = `${url}/${newsBlog[item].image[0]}`;
                      let title = newsBlog[item].title + "";
                      // if (i > from && i <= till) {
                      return (
                        <div className="row no-gutters m-2 mr-0 " key={i}>
                          <div className="col-md-4">
                            <img
                              src={src}
                              alt="blog image"
                              className="img-fluid w-100 h-100"
                            />
                          </div>
                          <div className="col-md-8">
                            <div className="card-body">
                              <Tooltip
                                title={title}
                                arrow
                                classes={{ tooltip: classes.customWidth }}
                              >
                                <h5 className="card-title title">
                                  {newsBlog[item].title}
                                </h5>
                              </Tooltip>
                              <p
                                className="card-text description"
                                dangerouslySetInnerHTML={{
                                  __html: newsBlog[item].details,
                                }}
                              ></p>
                              <Link
                                exact
                                to={"/blog/" + blogId}
                                params={{ testvalue: "hello" }}
                              >
                                <p className="continueRead">
                                  Continue Reading
                                  <ArrowForwardIcon
                                    style={{ fontSize: "14px" }}
                                  />
                                </p>
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                      // }
                    })}

                  <div className="">
                    <div className={classes.root}>
                      {/* <Pagination
                        className="float-right p-2"
                        variant="outlined"
                        hideNextButton={true}
                        hidePrevButton={true}
                        count={length}
                        color="primary"
                        onClick={(e) => {
                          setN(e.target.outerText);
                        }}
                      /> */}
                    </div>
                  </div>
                </div>
                <div className="mx-auto text-lg-right">
                  {!buttonLoad ? (
                    // <button
                    //   className="headlineButton
                    //   more-btn
                    //   mb-2
                    //   hvr-shutter-out-horizontal
                    //   border-0
                    //   mx-auto"
                    //   style={{
                    //     width: "200px",
                    //   }}
                    //   onClick={showMore}
                    // >
                    //   Show More
                    // </button>
                    <Link exact to="#" onClick={showMore}>
                      <p className="continueRead">
                        See all stories
                        <ArrowForwardIcon style={{ fontSize: "14px" }} />
                      </p>
                    </Link>
                  ) : (
                    <CircularProgress disableShrink />
                  )}
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="right-sponsor">
                <RightSponsers />
              </div>
            </div>
          </div>
        </div>
        <div className="container mt-5">
          <h3 style={{ textAlign: "center" }}>
            <FormatQuoteRoundedIcon
              className="mb-3"
              style={{ fontSize: "42px", transform: "rotate(180deg)" }}
            />
            <span>
              The purpose of 121five.com is to bring news and information from
              leaders in aviation directly to readers, in a setting that
              furthers aviation safety, technology, business and fun.
            </span>
            <FormatQuoteRoundedIcon
              className="mb-2"
              style={{ fontSize: "42px" }}
            />
          </h3>
        </div>
      </section>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
